function apiFactory() {
  const apiCommonMethods = [
    // It may return 403 if JSON object is too big, because of
    // too many checklists or too many customFields
    // use fields param to aviod it
    ['getAllCards', '/boards/{boardId}/cards/all'],
    ['getVisibleCards', '/boards/{boardId}/cards/visible'],
    ['getLists', '/boards/{boardId}/lists'],
    ['getList', '/lists/{listId}'],
    ['getCard', '/cards/{cardId}'],
    ['getCardActions', '/cards/{cardId}/actions'],
    ['getCardPluginData', '/cards/{cardId}/pluginData'],
    ['getOrganization', '/organizations/{idOrganization}'],
    [
      'getOrganizationMemberships',
      '/organizations/{idOrganization}/memberships',
    ],
    ['getOrganizationBoards', '/organizations/{idOrganization}/boards'],
    ['getBoard', '/boards/{boardId}'],
    ['getBoardMemberships', '/boards/{boardId}/memberships'],
    ['getBoardMembers', '/boards/{boardId}/members'],
    ['getBoardLabels', '/boards/{boardId}/labels'],
    ['getBoardCustomFields', '/boards/{boardId}/customFields'],
    ['getAuthMember', '/members/me'],
    ['getMember', '/members/{memberId}'],
    ['getMemberBoards', '/members/{memberId}/boards'],
    ['search', '/search'],
  ];

  let baseHeaders = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  };
  let makeRequest = () => {};
  let trelloApiKey = null;
  let token = null;
  const baseApiUrl = 'https://api.trello.com/1';
  let mockMethods = {};

  function fillUrlTemplate(template, templateVars) {
    const re = new RegExp('{', 'g');
    return new Function(
      /* eslint-disable-line */ `return \`${template.replace(re, '${this.')}\`;`
    ).call(templateVars);
  }

  function buildQueryUrl(params = {}, endpointUrl, baseUrl) {
    const urlInstance = new URL(
      `${baseUrl}${fillUrlTemplate(endpointUrl, params)}`
    );

    urlInstance.search = new URLSearchParams({
      ...params,
      key: trelloApiKey,
      token,
    });
    return urlInstance.toString();
  }

  function performFetch({
    methodName,
    endpointUrl,
    baseUrl,
    method,
    params,
    body,
    headers,
  }) {
    const url = buildQueryUrl(params, endpointUrl, baseUrl);

    if (mockMethods[methodName]) {
      return mockMethods[methodName]({
        ...params,
        url,
        endpointUrl,
      });
    }

    return makeRequest({
      url,
      method,
      headers: { ...baseHeaders, ...headers },
      ...(Object.keys(body).length
        ? {
            data: JSON.stringify(body),
          }
        : {}),
    });
  }

  return {
    init({ req }) {
      makeRequest = req;
    },

    setHeaders(newHeaders) {
      baseHeaders = newHeaders;
      return baseHeaders;
    },

    setKeyAndToken(newKey, newToken) {
      trelloApiKey = newKey;
      token = newToken;
    },

    getTrelloToken: () => token,
    getTrelloApiKey: () => trelloApiKey,

    isKeyAndTokenExists() {
      return trelloApiKey !== null && token !== null;
    },

    setMockMethods(mockObject, merge = true) {
      mockMethods = merge
        ? {
            ...mockMethods,
            ...mockObject,
          }
        : mockObject;

      return mockMethods;
    },

    clearMockMethods() {
      mockMethods = {};
      return mockMethods;
    },

    ...apiCommonMethods.reduce(
      (acc, [methodName, endpointUrl, method = 'GET', baseUrl]) => ({
        ...acc,
        [methodName](
          { params = {}, body = {}, headers } = {
            params: {},
            body: {},
            headers: {},
          }
        ) {
          return performFetch({
            methodName,
            endpointUrl,
            baseUrl: baseUrl || baseApiUrl,
            method,
            params,
            body,
            headers,
          });
        },
      }),
      {}
    ),
  };
}

const api = apiFactory();

export default api;
